import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';
import '@tokens/motion.stylex';
import { motion } from '@tokens/motion.stylex';
export const styles = {
  row: {
    k1xSpc: "x78zum5",
    kOIVth: "x1fwedmp",
    kGNEyG: "x6s0dn4",
    $$css: true
  },
  box: {
    kzqmXN: "x187nhsf",
    kZKoxP: "xdd8jsf",
    k9WMMc: "x2b8uid",
    kWkggS: "xvys5x3",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1xo1f5v",
    kaIpWk: "xxltkoq",
    kMwMTN: "x1oezkus",
    kMv6JI: "x1gs96k",
    kGuDYH: "xwsyq91",
    k63SB2: "xomqrzn",
    kI3sdo: "x1a2a7pz",
    kmkexE: "x1k3q35m",
    knGrYV: "xbuiw85",
    k4mVRr: "xwo1ljg",
    kWEjV4: "xs8x3o8",
    kL3a3j: "xxgwfau",
    kWCcOm: "xfqoyci",
    kYPGJ8: "x1s07b3s",
    $$css: true
  },
  boxFilled: {
    kVAM5u: "xa126vr",
    kWkggS: "x13uruat",
    $$css: true
  },
  boxInvalid: {
    kVAM5u: "x1vgqim1",
    kWkggS: "x8qqj1s",
    $$css: true
  }
};